import React from 'react';

const SvgCommunication32 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M14 8.5a.5.5 0 0 1-.5.5H11v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V9H6.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H9V4.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V7h2.5a.5.5 0 0 1 .5.5zM16 0H4a4 4 0 0 0-4 4v15.5a.5.5 0 0 0 .5.5.49.49 0 0 0 .35-.15l3-3A3 3 0 0 1 6 16h10a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgCommunication32 svgRef={ref} {...props} />);
export default ForwardRef;
